import React, { FunctionComponent } from 'react'

export interface Props {
  color?: string
}

export const AnalyticsIcon: FunctionComponent<Props> = ({
  color = 'currentColor',
}) => (
  <svg
    width="45px"
    height="45px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Analytics</title>
    <desc>Analytics chart icon</desc>
    <g
      id="analytics-icon"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="analytics-chart" fill={color} fillRule="nonzero">
        {/* Bar chart bars */}
        <rect x="3" y="14" width="4" height="7" rx="1" />
        <rect x="10" y="9" width="4" height="12" rx="1" />
        <rect x="17" y="4" width="4" height="17" rx="1" />
        {/* Base line */}
        <rect x="2" y="21" width="20" height="2" rx="0.5" />
      </g>
    </g>
  </svg>
)
